import { cn } from "@conlit/ui";

export interface BrandLogoProps {
  className?: string;
  size?: "compact" | "default";
}

export function BrandLogo({ className, size = "compact" }: BrandLogoProps) {
  return (
    <span
      className={cn(
        "relative block shrink-0 overflow-hidden",
        size === "compact" ? "h-12 w-40" : "h-16 w-52",
        className,
      )}
    >
      <img
        src="/brand/conlit-logo.png"
        alt="ConLit"
        width={1536}
        height={1024}
        className={cn(
          "absolute left-1/2 top-1/2 max-w-none -translate-x-1/2 -translate-y-1/2",
          size === "compact" ? "w-56" : "w-72",
        )}
      />
    </span>
  );
}
